import {cn} from "@/lib/utils";

import {DeltaPill} from "./delta-pill";
import {KpiCard, type KpiCardDensity} from "./kpi-card";

type KpiCardSimpleProps = {
  label: string;
  icon?: React.ElementType;
  current: number;
  previous: number;
  deltaPct: number | null;
  density?: KpiCardDensity;
  selected?: boolean;
  onSelect?: () => void;
};

/**
 * Default KPI tile for `current` / `previous` / `delta_pct` shape:
 * citations, incidents, pool access, dispatch.
 */
export function KpiCardSimple({
  label,
  icon,
  current,
  previous,
  deltaPct,
  density = "default",
  selected,
  onSelect,
}: KpiCardSimpleProps) {
  const isCompact = density === "compact";

  return (
    <KpiCard
      label={label}
      icon={icon}
      density={density}
      selected={selected}
      onSelect={onSelect}
    >
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
        <span
          className={cn(
            "text-foreground min-w-0 font-bold tracking-tight tabular-nums",
            isCompact ? "text-3xl" : "text-4xl",
          )}
        >
          {current.toLocaleString()}
        </span>
        <DeltaPill value={deltaPct} size={isCompact ? "sm" : "default"} className="shrink-0" />
      </div>
      <p className={cn("text-muted-foreground text-sm leading-snug", isCompact && "mt-auto")}>
        from <span className="tabular-nums">{previous.toLocaleString()}</span> last period
      </p>
    </KpiCard>
  );
}
